let controllers = [];

export function createController() {
    const controller = new AbortController();

    controllers.push(controller);

    return controller;
}

export function cancelAllRequests() {
    controllers.forEach(controller => controller.abort());

    controllers = [];
}
